<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.8438 9.875V16.125M10.1562 16.125V9.875M21.875 13C21.875 18.1777 17.6777 22.375 12.5 22.375C7.32233 22.375 3.125 18.1777 3.125 13C3.125 7.82233 7.32233 3.625 12.5 3.625C17.6777 3.625 21.875 7.82233 21.875 13Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPauseCircle',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
